module.exports = __webpack_public_path__ + "static/media/Samwell Tarley.ee867647.jpg";